(() => {
  const page = document.querySelector('#vh-glove');
  if (!page) return;
  const live = JSON.parse(document.querySelector('#vh-shopify-data').textContent);
  const money = value => new Intl.NumberFormat('en-US', {style:'currency',currency:live.currency || 'USD'}).format(value / 100);
  const orderBenefits = ['Pet Odor Guide Ebook', '10% Voucher for Other Products', 'Free Shipping'];
  const complimentaryProduct = JSON.parse(document.querySelector('#complimentary-product-data').textContent);
  const offers = [
    {id:'single', title:'Single', quantity:1, price:2499, gifts:orderBenefits},
    {id:'duo', title:'Duo', quantity:2, price:2999, gifts:[...orderBenefits, complimentaryProduct.label]},
    {id:'trio', title:'Trio', quantity:3, price:3699, gifts:orderBenefits},
    {id:'family', title:'Buy 2 Get 2 Free', quantity:4, price:4399, gifts:orderBenefits}
  ];
  offers.forEach(offer => {
    offer.variant = live.variants.find(v => v.sku === 'VH-GLOVE-' + offer.quantity);
    if (offer.variant) offer.price = offer.variant.price;
  });
  let selected = offers[1];
  const initial = offers.find(o => String(o.variant?.id) === new URLSearchParams(location.search).get('variant'));
  if (initial) page.querySelector('[name="glove-pack"][value="'+initial.id+'"]').checked = true;
  page.querySelectorAll('[name="glove-pack"]').forEach(input => {
    const offer = offers.find(o => o.id === input.value);
    const label = input.closest('.offer');
    label.querySelector('.offer-prices b').textContent = money(offer.price);
    const normal = offers[0].price * offer.quantity;
    if (label.querySelector('del')) label.querySelector('del').textContent = money(normal);
    if (label.querySelector('.offer-save')) label.querySelector('.offer-save').textContent = 'Save '+((normal-offer.price)/normal*100).toFixed(1)+'%';
    input.setAttribute('aria-label', offer.title+': '+offer.quantity+' glove'+(offer.quantity>1?'s':'')+', '+money(offer.price));
  });
  function syncOffer() {
    selected = offers.find(x => x.id === page.querySelector('[name=glove-pack]:checked').value);
    page.querySelector('#add-to-cart').innerHTML = '<span>Add to cart</span><span class="buy-divider" aria-hidden="true"></span><span class="buy-price">' + money(selected.price) + '</span>';
    page.querySelector('#add-to-cart').setAttribute('aria-label', 'Add ' + selected.quantity + ' glove' + (selected.quantity === 1 ? '' : 's') + ' to cart for ' + money(selected.price));
    page.querySelector('#sticky-add').textContent = 'Add to cart · ' + money(selected.price);
    page.querySelector('#sticky-set').textContent = selected.title + ' · ' + selected.quantity + ' glove' + (selected.quantity > 1 ? 's' : '');
    page.querySelector('#comb-bonus').hidden = !complimentaryProduct.eligible_offer_ids.includes(selected.id);
    const available = !!selected.variant?.available;
    page.querySelector('#add-to-cart').disabled = !available;
    page.querySelector('#sticky-add').disabled = !available;
    if (!available) page.querySelector('#add-to-cart').textContent = 'Currently unavailable';
  }
  page.querySelectorAll('[name=glove-pack]').forEach(r => r.addEventListener('change', syncOffer));
  syncOffer();

  const thumbs = [...page.querySelectorAll('.thumb')], main = page.querySelector('#main-image');
  let slide = 0;
  function showSlide(index) {
    slide = (index + thumbs.length) % thumbs.length;
    const t = thumbs[slide];
    main.src = t.dataset.image; main.alt = t.dataset.alt;
    page.querySelector('#image-counter').textContent = (slide + 1) + ' / ' + thumbs.length;
    thumbs.forEach((b,i) => b.setAttribute('aria-pressed', String(i === slide)));
    t.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
  }
  thumbs.forEach((b,i) => b.addEventListener('click', () => showSlide(i)));
  page.querySelector('#gallery-prev').addEventListener('click', () => showSlide(slide - 1));
  page.querySelector('#gallery-next').addEventListener('click', () => showSlide(slide + 1));
  page.querySelector('.gallery-frame').addEventListener('keydown', e => {if(e.key === 'ArrowRight'){e.preventDefault();showSlide(slide+1)}if(e.key === 'ArrowLeft'){e.preventDefault();showSlide(slide-1)}});

  const actionTrack = page.querySelector('#action-track');
  page.querySelector('#action-next').addEventListener('click', () => actionTrack.scrollBy({left:actionTrack.querySelector('.action-card').clientWidth+17,behavior:'smooth'}));
  page.querySelector('#action-prev').addEventListener('click', () => actionTrack.scrollBy({left:-actionTrack.querySelector('.action-card').clientWidth-17,behavior:'smooth'}));

  page.querySelectorAll('.action-showcase-card').forEach(card => {
    const video = card.querySelector('video');
    const playButton = card.querySelector('.action-showcase-play');
    video.controls = false;
    playButton.hidden = false;
    playButton.addEventListener('click', () => {
      video.controls = true;
      video.play().catch(() => { playButton.hidden = false; });
    });
    video.addEventListener('play', () => { playButton.hidden = true; });
    video.addEventListener('pause', () => { playButton.hidden = false; });
    video.addEventListener('ended', () => { playButton.hidden = false; });
  });

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if ('IntersectionObserver' in window) {
    const videos = new IntersectionObserver(entries => entries.forEach(({target,isIntersecting}) => {
      if(isIntersecting && !reduced){target.play().catch(()=>{});} else {target.pause();}
    }), {threshold:.2});
    page.querySelectorAll('video:not([data-manual-play])').forEach(v => videos.observe(v));
    new IntersectionObserver(([e]) => page.querySelector('#sticky').classList.toggle('visible', !e.isIntersecting && e.boundingClientRect.top < 0), {threshold:0}).observe(page.querySelector('#add-to-cart'));
  }
  const cartMessage = document.querySelector('#vh-cart-message');
  let adding = false;
  let packAdded = false;
  async function addPack() {
    if (adding || !selected.variant?.available) return;
    adding = true;
    if (packAdded) { location.href = live.root+'cart'; return; }
    const chosen = selected;
    const buttons = [page.querySelector('#add-to-cart'),page.querySelector('#sticky-add')];
    buttons.forEach(b => {b.disabled=true; b.textContent='Adding…';});
    cartMessage.hidden = true;
    const properties = {
      'Gloves per set': String(chosen.quantity),
      'Included Ebook': 'Pet Odor Guide',
      'Ebook download': live.ebookUrl,
      '10% voucher for other products': live.voucherCode,
      '_vh_glove_offer': chosen.id
    };
    const items = [{id:chosen.variant.id,quantity:1,properties}];
    if (chosen.id === 'duo') items.push({id:live.giftVariantId,quantity:1,properties:{'Gift for':'VelaHush Glove Duo','_vh_glove_gift':'duo'}});
    try {
      const response = await fetch(live.root+'cart/add.js', {
        method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Unable to add this set. Please try again.');
      packAdded = true;
      if (window.vhGloveSyncGifts) await window.vhGloveSyncGifts();
      location.href = live.root+'cart';
    } catch (error) {
      cartMessage.textContent = error.message;
      cartMessage.hidden = false;
      adding = false;
      syncOffer();
      if (packAdded) buttons.forEach(b => {b.textContent='View your cart';});
    }
  }
  page.querySelector('#add-to-cart').addEventListener('click',addPack);
  page.querySelector('#sticky-add').addEventListener('click',addPack);
  document.querySelector('#open-cart').addEventListener('click',()=>{location.href=live.root+'cart';});
})();
